<template>
  <form-box title="种植信息">
    <el-form
      ref="plantInfoForm"
      class="form-box"
      size="medium"
      label-position="top"
      :model="plantInfoForm"
      :rules="rules"
    >
      <div class="form-row">
        <!-- 左侧表单 -->
        <div class="form-column">
          <el-form-item label="种植平均亩产" prop="avgAcre">
            <el-input
              v-model="plantInfoForm.avgAcre"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="10"
              placeholder="请输入种植平均亩产"
            >
              <template slot="append">斤/亩</template>
            </el-input>
          </el-form-item>
          <el-form-item label="当地标准亩产" prop="standardAcre">
            <el-input
              v-model="plantInfoForm.standardAcre"
              :disabled="type === 'check'"
              class="ipt"
              maxlength="10"
              placeholder="请输入当地标准亩产"
            >
              <template slot="append">斤/亩</template>
            </el-input>
          </el-form-item>
        </div>
        <!-- 右侧表单 -->
        <div class="form-column">
          <el-form-item label="是否为预计" prop="avgAcreStatus">
            <el-select
              :disabled="type === 'check'"
              v-model="plantInfoForm.avgAcreStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="item in allSelectData.standardAcreStatusArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否为预计" prop="standardAcreStatus">
            <el-select
              :disabled="type === 'check'"
              v-model="plantInfoForm.standardAcreStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="item in allSelectData.standardAcreStatusArr"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
export default {
  name: "PlantInfo",
  components: {
    FormBox,
  },
  props: {
    plantInfoForm: {
      type: Object,
      default() {
        return {};
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateNumAndEmpty = (rule, value, callback) => {
      const pattern = /^\d{0,10}(\.\d{0,2})?$/g;
      if (value && !pattern.test(value)) {
        callback(
          new Error(`${rule.message}必须为数字（整数或保留两位小数）或者空`)
        );
      } else {
        callback();
      }
    };
    return {
      rules: {
        avgAcre: [
          { required: true, message: "请输入种植平均亩产", trigger: "blur" },
          {
            validator: validateNumAndEmpty,
            message: "种植平均亩产必须为数字（整数或保留两位小数）",
            trigger: "blur",
          },
        ],
        standardAcre: [
          { required: true, message: "请输入当地标准亩产", trigger: "blur" },
          {
            validator: validateNumAndEmpty,
            message: "当地标准亩产必须为数字（整数或保留两位小数）",
            trigger: "blur",
          },
        ],
        avgAcreStatus: [
          { required: true, message: "请选择是否为预计", trigger: "change" },
        ],
        standardAcreStatus: [
          { required: true, message: "请选择是否为预计", trigger: "change" },
        ],
      },
    };
  },
};
</script>

<style scoped lang="scss">
.form-box {
  .form-row {
    display: flex;
    background: #f7f9fb;
    .form-column {
      padding: 40px 0 30px 100px;
      flex: 1;
      ::v-deep .el-form-item__label {
        line-height: normal !important;
      }
      .ipt,
      .el-select {
        width: 374px;
      }
    }
  }
}
</style>
